import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

type Props = {
  showBranchSelector?: boolean
}

export const PublicGitInput = ({ showBranchSelector = true }: Props) => {
  const form = useFormContext()
  const { resetField } = form

  useEffect(() => {
    return () => {
      resetField('repoUrl')
      resetField('defaultBranch')
    }
  }, [resetField])

  return (
    <div className={cn(showBranchSelector ? 'grid grid-cols-3 gap-4' : '')}>
      <div className={cn(showBranchSelector ? 'col-span-2' : '')}>
        <FormField
          control={form.control}
          name="repoUrl"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Repository url</FormLabel>
              <FormControl>
                <Input
                  autoComplete="off"
                  placeholder="https://github.com/example/repo"
                  aria-label="Repository URL"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      {showBranchSelector ? (
        <div className="col-span-1">
          <FormField
            control={form.control}
            name="defaultBranch"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Branch</FormLabel>
                <FormControl>
                  <Input
                    autoComplete="off"
                    placeholder="main"
                    aria-label="Branch"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      ) : null}
    </div>
  )
}
